const keyMirror = require("keymirror");

export const AccountsConstants = keyMirror({
  FETCH_ACCOUNTS: undefined,
  SET_ACCOUNTS: undefined,
  SET_RE_LOGIN_REQUIRED_INSTITUTES: undefined
});
